// import { useTranslations } from 'next-intl';
import React from 'react'
import Header from '../Components/Common/Header';
import ContactInfo from '../Components/Contactus/ContactInfo';
import Map from '../Components/Contactus/Map';
import { useSelector } from 'react-redux';
import Navbar from '../Components/Navbar/Navbar'
import Contactus from '../Components/Contactus/Contactus'
import Footer from '../Components/Footer/Footer'

export default function Index() {
  const { currentLocal } = useSelector((state) => state.currentLocal);
  return (
    <div>
      <Navbar/>
      <Header title={currentLocal.general.contact} />
      <ContactInfo />
      <Map />
      <Contactus/>
      <Footer/>
    </div>
  )
}
